export default "__VITE_ASSET__CVJQW2yq__"